import React from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { mapDispatchToProps } from '../../../helpers/redux.helper'
import VideoContent from '../VideoContent'
import AudioContent from '../AudioContent'

const AudioVideoContent = ({
  video,
  audio,
  t,
  isAudioPlaying,
  actions: {
    toggleFavoriteVoice,
    changeModalVisibility,
    toggleVisibleAudioPlayer,
    setPlayingStatus,
    setPlayingVoiceId,
    setChoosenVoice,
  },
  currentVoiceId,
}) => {
  if (!video && !audio) return null

  return (
    <>
      {video ? (
        <VideoContent
          title={t('services.videoExp')}
          text={video.title && t(`serviceDetails.${video.title}`)}
          video={video.video}
        />
      ) : (
        <AudioContent
          title={t('services.audioExp')}
          text={audio.title && t(`serviceDetails.${audio.title}`)}
          audioList={audio.audioList}
          changeModalVisibility={changeModalVisibility}
          toggleFavoriteVoice={toggleFavoriteVoice}
          toggleVisibleAudioPlayer={toggleVisibleAudioPlayer}
          setPlayingStatus={setPlayingStatus}
          currentPlayingVoice={{ currentVoiceId, isAudioPlaying }}
          setPlayingVoiceId={setPlayingVoiceId}
          setChoosenVoice={setChoosenVoice}
          hasVoiceSescr={false}
        />
      )}
    </>
  )
}

const mapStateToProps = state => ({
  currentVoiceId: state.audioPlayer.currentVoiceId,
  isAudioPlaying: state.audioPlayer.isPlaying,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AudioVideoContent)
)
